import React, { FC, PropsWithChildren } from 'react';
import { Modal } from 'reactstrap';

import CloseIcon from 'material-react-icons/Close';

import styles from './FullscreenModal.module.scss';

interface FullscreenModalProps {
  visible: boolean;
  close: () => void;
}

const FullscreenModal: FC<PropsWithChildren<FullscreenModalProps>> = props => {
  const { visible, close, children } = props;

  return (
    <Modal
      isOpen={visible}
      toggle={close}
      className={styles.modal}
      contentClassName={styles.content}
      centered
    >
      <div className={styles.close}>
        <button
          type="button"
          onClick={e => {
            e.preventDefault();
            close();
          }}
        >
          <CloseIcon size={32} color="white" />
        </button>
      </div>
      {children}
    </Modal>
  );
};

export default FullscreenModal;
